import React, { useMemo, useState } from "react";
import * as _ from "lodash";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
// import { GET_ORDERS } from "../../../graphql/order/query";
import { Button, Spinner } from "react-bootstrap";
// import useReactRouter from "use-react-router";
import { useMutation } from "@apollo/client";
import { CANCELLED, COLOR_APP } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
//   faArrowRotateBack,
//   faCancel,
  faReply,
} from "@fortawesome/free-solid-svg-icons";
import { MdOutlineContentCopy } from "react-icons/md";
import BasicModal from "../../../components/BasicModal";
import { CANCEL_ORDER, CANCEL_ORDER_V2 } from "../../../graphql/order/mutation";
import Illustration from "../../../image/Illustration.png";
import { useToasts } from "react-toast-notifications";
// import { convertOrderStatus } from "../../../helpers/orderStatus";
import { MdOutlineRefresh } from "react-icons/md";

// style
function OrderLiveScreen({
    restoreAmountAndCancelOrder,
    createResp,
    fetchLiveStocks,
    fetchLiveOrders,
    orders,
    totalOrder,
    liveData,
    loadingOrders,
    }) {
    const { addToast } = useToasts();
    const { height, width } = useWindowDimensions();
    const newOrders = useMemo(() => { return orders ?? []}, [orders]);
    const newTotalOrder = useMemo(() => { return orders ? orders.length : 0 }, [orders]);
    
    // const [cancelOrder, { loading: cancelOrderLoading }] =
    // useMutation(CANCEL_ORDER);
    const [cancelOrderV2, { loading: cancelOrderLoadingV2 }] =
    useMutation(CANCEL_ORDER_V2);

    // State
    const [showCancelConfirm, setShowCancelConfirm] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState();
    const [cancelMsgs, setCancelMsgs] = useState({});

    // Function
    const _onCancelOrder = async () => {
        try {
        // return console.log({ selectedOrder })
        if (selectedOrder?.status === CANCELLED || cancelOrderLoadingV2) return;
        const _res = await cancelOrderV2({ 
            variables: {
            where: {
                id: selectedOrder?.id,
            },
            },
        });
        if (_.isEmpty(_res?.data?.cancelOrderV2?.data?.id)) {
            setShowCancelConfirm(false);
            addToast(`ຍົກເລີກອໍເດີ້ບໍ່ສຳເລັດແລ້ວ`, {
            appearance: "warning",
            autoDismiss: true,
            });
            return;
        }
        const orderData = _res?.data?.cancelOrderV2;
        const msgRes = orderData?.msg;
        if (msgRes && selectedOrder?.id) {
            setCancelMsgs((prev) => ({ ...prev, [selectedOrder.id]: msgRes }));
        }

        restoreAmountAndCancelOrder(
            selectedOrder?.id,
            selectedOrder?.liveStock?.id,
            selectedOrder?.amount,
            orderData?.isCancelled
        );
        // fetchLiveStocks();
        // fetchLiveOrders();

        setShowCancelConfirm(false);
        addToast(`ຍົກເລີກອໍເດີ້ສຳເລັດແລ້ວ`, {
            appearance: "success",
            autoDismiss: true,
        });
        return _res
        } catch (error) {
            console.log("Error in _onCancelOrder:", error);
            addToast('ຍົກເລີກອໍເດີ້ບໍ່ສຳເລັດແລ້ວ', {
                appearance: "error",
                autoDismiss: true,
            });
        }
    };
    

    return (
        <div
            style={{
                padding: 10,
                background: "#F5F5FA",
                gap: 5,
                display: "flex",
                flexDirection: "column",
                border: "1px solid #F5F5FA",
                borderRadius: 10,
                height: width > 700 ? "82vh" : "70vh",
            }}
        >
        <div
            style={{
                color: COLOR_APP,
                fontSize: 18,
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            ອໍເດີ້ທັງໝົດ ({newTotalOrder})
            <Button
            onClick={() => fetchLiveOrders()}
            style={{ background: COLOR_APP, border: "none" }}
            >
            {loadingOrders ? (
                <Spinner size="sm" animation="border" />
            ) : (
                <MdOutlineRefresh />
            )}{" "}
            ໂຫຼດຂໍ້ມູນ
            </Button>
        </div>
        <div
            className="row mb-2"
            style={{
            border: "1px solid #FFFF",
            fontWeight: "bold",
            fontSize: 12,
            margin: "2px 0px",
            padding: "2px 0px",
            background: "#FFFF",
            borderRadius: 5,
            }}
        >
            <div className="col-3">ລູກຄ້າ</div>
            <div className="col-2" style={{ alignSelf: "center" }}>
            ລະຫັດ
            </div>
            <div
            className="col-2"
            style={{ whiteSpace: "nowrap", alignSelf: "center" }}
            >
            ຈໍານວນ
            </div>
            <div
            className="col-3"
            style={{ whiteSpace: "nowrap", alignSelf: "center" }}
            >
            ຂໍ້ຄວາມແຈ້ງ ລຄ
            </div>
            <div
            className="col-2"
            style={{ whiteSpace: "nowrap", alignSelf: "end" }}
            >
            ກ໋ອບຂໍ້ຄວາມ
            </div>
            {/* <div className="col-3" style={{ alignSelf: 'center', textAlign: 'center', padding: 0 }}>ຈັດການ</div> */}
        </div>
        <div style={{ overflow: "scroll" }}>
            {newOrders &&
            newOrders?.length > 0 &&
            newOrders?.map((order) => {
                return (
                <div
                    key={order?.id}
                    className="row"
                    style={{
                    border: "1px solid #FFFF",
                    margin: "1px 0px",
                    padding: "4px 0px",
                    background: "#FFFF",
                    borderRadius: 5,
                    }}
                >
                    <div className="col-3" style={{ fontSize: 12 }}>
                    {order?.cfName}
                    </div>
                    <div
                    className="col-2"
                    style={{
                        alignSelf: "center",
                        textAlign: "center",
                        fontSize: 12,
                        border: "1px solid " + "#5357B6",
                        color: "#5357B6",
                        padding: "2px 2px",
                        borderRadius: 8,
                    }}
                    >
                    {order?.cfMessage}
                    </div>
                    <div
                    className="col-2"
                    style={{
                        alignSelf: "center",
                        textAlign: "center",
                        fontSize: 12,
                        fontWeight: "bold",
                    }}
                    >
                    {order?.amount}
                    </div>
                    <div
                    className="col-2"
                    style={{
                        alignSelf: "center",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        borderRadius: 8,
                        fontSize: 10,
                        padding: 2,
                        color: order?.isReply ? "green" : `${order?.isCancelled && order?.status === "CANCELLED" ? "red" : "orange"}`,
                        border: "1px solid " + (order?.isReply ? "green" : `${order?.isCancelled && order?.status === "CANCELLED" ? "red" : "orange"}`),
                    }}
                    >
                    {order?.isReply ? "ສົ່ງຂໍ້ຄວາມແລ້ວ" : `${order?.isCancelled && order?.status === "CANCELLED" ? "ຍົກເລີກແຕ່ບໍ່ສົ່ງ ຂຄ" : "ສົ່ງຂໍ້ຄວາມບໍ່ອອກ"}`}
                    </div>
                    {/* <div className="col-2" style={{ alignSelf: 'center', whiteSpace: 'nowrap', textAlign: 'center', borderRadius: 8, fontSize: 12, color: order?.status === CANCELLED ? "red" : "green" }}>{convertOrderStatus(order?.status)}</div> */}
                    <div
                    className="col-2"
                    style={{
                        alignSelf: "center",
                        textAlign: "center",
                        padding: 0,
                    }}
                    >
                    <Button
                        onClick={() => {
                        setSelectedOrder(order);
                        setShowCancelConfirm(true);
                        }}
                        disabled={order?.status === CANCELLED}
                        style={{
                        background: "transparent",
                        color: order?.status === CANCELLED ? "red" : "#5357B6",
                        borderColor:
                            order?.status === CANCELLED ? "red" : "#5357B6",
                        padding: "2px 3px",
                        whiteSpace: "nowrap",
                        borderRadius: 8,
                        fontWeight: "bold",
                        fontSize: 12,
                        }}
                    >
                        <FontAwesomeIcon icon={faReply} /> ຍົກເລີກ
                    </Button>
                    </div>
                    {/* copy message */}
                    <div className="col-1" style={{ alignSelf: 'center', whiteSpace: 'nowrap', textAlign: 'center',fontSize: 12, color: "green" }}>
                        <Button
                            onClick={() => {
                                const text = cancelMsgs?.[order?.id] ?? order?.unsendMessage ?? "";
                                if (!text) return;
                                navigator.clipboard.writeText(text)
                                .then(() => addToast("ຄັດລອກແລ້ວ", { appearance: "success", autoDismiss: true }))
                                .catch(() => addToast("ຄັດລອກບໍ່ສຳເລັດ", { appearance: "error", autoDismiss: true }));
                            }}
                            style={{
                                background: "transparent",
                                color: order?.isReply ? "green" : `${order?.isCancelled && order?.status === "CANCELLED" ? "red" : "orange"}`,
                                borderColor:
                                order?.isReply ? "green" : `${order?.isCancelled && order?.status === "CANCELLED" ? "red" : "orange"}`,
                                padding: "2px 3px",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                                fontSize: 12,
                            }}
                        >
                            <MdOutlineContentCopy style={{ fontSize: 12 }} />
                        </Button>
                    </div>
                </div>
                );
            })}
        </div>
        <BasicModal
            show={showCancelConfirm}
            onHide={() => setShowCancelConfirm(false)}
            okay={_onCancelOrder}
            title="ທ່ານຕ້ອງການຍົກເລີກລາຍການອໍເດີ່ນີ້ແທ້ ຫຼື ບໍ່?"
            leftButtonName="ຍົກເລີກ"
            rightButtonName={
            cancelOrderLoadingV2 ? (
                <Spinner animation="border" size="sm" />
            ) : (
                "ຕົກລົງ"
            )
            }
            Illustration={Illustration}
        />
        </div>
    );
}

export default OrderLiveScreen;
